<div class=" h-full w-full">
    <div class="py-28 min-h-[70vh]">

    
<div class="not-found-container">
  <img src="assets/logo-long.png" alt="logo" i18n-alt class="mb-10  h-[64px]">
  <h1 class="title" i18n>404 - Page Not Found</h1>
  <p class="description" i18n>
    The page you are looking for doesn't exist or has been moved.
  </p>
  <p-button appGlobalLoadingDisable 
  type="button" 
  class="w-full text-base cursor-pointer text-white rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
  [routerLink]="['/']">
  <span i18n>Go to login</span>
</p-button>
  
</div>
</div>
</div>
